import React, { useEffect, useRef, useState } from "react";
import logo from "../../../assets/logo.png";
import { MdDashboard } from "react-icons/md";
import { FiBarChart2, FiSettings } from "react-icons/fi";
import { BiLogOut, BiRocket } from "react-icons/bi";
import { TbChartHistogram } from "react-icons/tb";
import { FaFlask } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BsFillMenuButtonWideFill } from "react-icons/bs";
import { AiOutlineExperiment } from "react-icons/ai";
import { logout } from "../../../features/auth/authSlice";
import { clearUser } from "../../../features/auth/userSlice";

const Navbar = ({ dispatch, state }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [ismenuOpen, setmenuIsOpen] = useState(false);
  const user = useSelector((state) => state.user.user);
  const navigate = useNavigate();

  const dis = useDispatch();

  // User object with email and name

  const menuItems = [
    { label: "Dashboard", icon: <MdDashboard size={16} />, split: false },
    // { label: "Usages", icon: <TbChartHistogram size={16} />, split: false },
    { label: "Settings", icon: <FiSettings size={16} />, split: true },
    { label: "Sign Out", icon: <BiLogOut size={16} />, split: true },
  ];

  const botItems = [
    {
      key: "sandbox",
      label: "Sandbox",
      icon: <FaFlask size={16} />,
    },
    { key: "deploy", label: "Deploy", icon: <BiRocket size={16} /> },
    {
      key: "activity",
      label: "Activity",
      icon: <TbChartHistogram size={16} />,
    },
    { key: "analytics", label: "Analytics", icon: <FiBarChart2 size={16} /> },

    { key: "settings", label: "Settings", icon: <FiSettings size={16} /> },
  ];

  const dropdownRef = useRef(null);
  const menudropdownRef = useRef(null);

  const handelLogout = () => {
    dis(clearUser());
    dis(logout());
  };

  const handleClick = (label) => {
    setIsOpen(false); // Close the dropdown on click
    // Handle different actions based on the label
    if (label === "Sign Out") {
      handelLogout();
      return;
    }

    if (label === "Home") {
      navigate("/");
      label = "Dashboard";
    }

    if (label === "Dashboard" || label === "Settings" || label === "Usages") {
      dispatch({ type: "SET_ACTIVE_MENU", payload: label.toLowerCase() });
      dispatch({ type: "SET_SELECTED_BOT", payload: null });
      dispatch({ type: "SET_NAV_ITEMS", payload: [] });
    }
  };

  const handleBotClick = (key) => {
    dispatch({ type: "SET_ACTIVE_BOT_MENU", payload: key });
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    // Cleanup event listener on unmount or when isOpen changes
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClickmenu = (event) => {
      if (
        menudropdownRef.current &&
        !menudropdownRef.current.contains(event.target)
      ) {
        setmenuIsOpen(false);
      }
    };

    if (ismenuOpen) {
      document.addEventListener("mousedown", handleOutsideClickmenu);
    } else {
      document.removeEventListener("mousedown", handleOutsideClickmenu);
    }

    // Cleanup event listener on unmount or when ismenuOpen changes
    return () => {
      document.removeEventListener("mousedown", handleOutsideClickmenu);
    };
  }, [ismenuOpen]);

  return (
    <header className="w-full sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200">
      <div className="flex justify-between items-center px-6 py-3 text-sm">
        {/* Logo + User Info */}
        <div className="flex items-center gap-2">
          <img
            src={logo}
            onClick={() => handleClick("Home")}
            alt="IMD Logo"
            className="w-9 h-9 cursor-pointer hover:opacity-80 transition"
          />
          <div className="hidden sm:flex text-gray-300 font-light text-xl">
            /
          </div>
          <div
            onClick={() => handleClick("Dashboard")}
            className="hidden sm:flex font-medium text-gray-800 hover:text-black cursor-pointer transition">
            {user?.name || user?.email}
          </div>

          {/* Bot Dropdown */}
          {state.bots?.length > 0 && state.isSelected && (
            <div className="ml-4 hidden sm:flex items-center gap-2">
              <span className="text-gray-300 font-light text-xl">/</span>
              <select
                className="px-2 py-1 rounded-md bg-gray-100 text-gray-700 font-medium focus:outline-none focus:ring"
                value={state.selectedBot?.botId || ""}
                onChange={(e) => {
                  const selected = state.bots.find(
                    (bot) => bot.botId === e.target.value
                  );
                  dispatch({ type: "SET_SELECTED_BOT", payload: selected });
                }}>
                <option value="" disabled>
                  Select a bot
                </option>
                {state.bots.map((bot) => (
                  <option key={bot.botId} value={bot.botId}>
                    {bot.botName}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        <div className="flex items-center gap-2">
          {state.isSelected && (
            <div className="flex md:hidden items-center justify-center p-2 -mr-2 rounded-full text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
              <button onClick={() => dispatch({ type: "Demo_Chat" })}>
                <span className="sr-only">Open Demo Chat</span>
                <AiOutlineExperiment size={30} />
              </button>
            </div>
          )}
          <div className="relative sm:hidden" ref={menudropdownRef}>
            <button
              aria-haspopup="true"
              aria-expanded={ismenuOpen}
              aria-controls="mobile-menu"
              className="flex items-center justify-center p-2  rounded-full text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={() => setmenuIsOpen((prev) => !prev)}>
              <span className="sr-only">Open main menu</span>
              <BsFillMenuButtonWideFill size={25} />
            </button>
            {ismenuOpen && (
              <div
                className="absolute -right-10  mt-2 w-56 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 animate-fade-in"
                id="mobile-menu"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button">
                <ul className="py-1" role="none">
                  {botItems.map(({ label, icon, key }) => (
                    <li
                      key={key}
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default link behavior
                        handleBotClick(key);
                        setmenuIsOpen(false);
                        dispatch({ type: "M_Demo_Chat", payload: false });
                        // Close menu on item click
                      }}
                      role="menuitem"
                      className={`flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-150 ${
                        state.activeBotMenus === key
                          ? "bg-indigo-50 text-indigo-700 font-semibold"
                          : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      }`}>
                      {icon}
                      <span>{label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Profile Dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              aria-haspopup="true"
              aria-expanded={isOpen}
              aria-controls="mobile-profile-menu"
              onClick={() => setIsOpen((prev) => !prev)}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 text-white font-bold text-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 transition"
              aria-label="User menu toggle">
              {user?.email?.[0]?.toUpperCase()}
            </button>

            {isOpen && (
              <div
                id="mobile-profile-menu"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
                className="absolute right-0 mt-2 w-64 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 animate-fade-in">
                <div className="px-4 py-3 border-b border-gray-200">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {user.email}
                  </p>
                  <p className="text-sm text-gray-500">
                    Subscription:{" "}
                    <span className="font-semibold text-gray-700">
                      {user?.plan?.type
                        ? user.plan.type.charAt(0).toUpperCase() +
                          user.plan.type.slice(1).toLowerCase()
                        : "N/A"}
                    </span>
                  </p>
                </div>
                <ul className="py-1" role="none">
                  {menuItems.map(({ label, icon, split }, idx) => (
                    <li
                      key={idx}
                      onClick={(e) => {
                        e.preventDefault();
                        handleClick(label);
                        setIsOpen(false); // Close menu on click
                        dispatch({ type: "M_Demo_Chat", payload: false });
                      }}
                      role="menuitem"
                      className={`flex items-center gap-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150 ${
                        split ? "border-t border-gray-200" : ""
                      }`}>
                      <span className="text-gray-400">{icon}</span>
                      <span>{label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Bot Navigation Tabs */}
      {state.isSelected && (
        <div className="-mt-3 bg-white shadow-sm  p-0 text-sm 2xl:text-base hidden  sm:flex sm:justify-center items-center">
          <ul className="flex justify-center items-center p-0 whitespace-nowrap">
            {botItems.map(({ label, icon, key }) => (
              <li
                key={key}
                onClick={() => {
                  handleBotClick(key);
                  dispatch({ type: "M_Demo_Chat", payload: false });
                }}
                className={`flex items-center gap-3 px-4 py-3 text-sm transition-colors duration-150 ${
                  state.activeBotMenus === key
                    ? "bg-indigo-50 text-indigo-700 font-semibold"
                    : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                }`}>
                <span>{icon}</span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
